import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-300">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                蘑菇视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-400">
              蘑菇视频官方正版视频平台，提供海量高清视频内容、安全下载和优质会员服务。选择正版，选择蘑菇视频。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/dianying" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">视频分类</Link></li>
              <li><Link to="/article/moguvideo-membership-guide" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">会员中心</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#hot-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/dianying" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">电视剧</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">动漫</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">综艺</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>support@lygshjx.com.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区蘑菇大厦</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 蘑菇视频 版权所有 | 京ICP备2024000000号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}